import { Fragment, useEffect } from 'react';
import { Navbar } from 'fileIndexing/otherComponents/Navbar';
import { NavigationMenu } from 'fileIndexing/otherComponents/NavigationMenu';

import { TaxonomyTable } from '../components/TaxonomyTable';

export function TaxonomyMainPage () {
    useEffect(() => {
        document.title = 'File Indexing - Taxonomies';
    }, []);

    return (
        <Fragment>
            <Navbar />
            <NavigationMenu />
            <TaxonomyTable />
        </Fragment>
    );
}